import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, identityClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getBusinessGroupsubscriptionDatatable: ApiMethod<
  Server.BusinessGroupSubscriptionsDataTableInput,
  Server.TableOfBusinessGroupSubscriptionColumns,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupSubscription_Client(
      undefined,
      identityClient
    );
    const response =
      await client.admin_BusinessGroupSubscription_datatable_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const createNewBusinessGroupsubscription: ApiMethod<
  Server.CreateBusinessGroupSubscriptionInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupSubscription_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupSubscription_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const expireBusinessGroupsubscription: ApiMethod<
  Server.ExpireBusinessGroupSubscriptionInput,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_BusinessGroupSubscription_Client(
      undefined,
      identityClient
    );
    const response = await client.admin_BusinessGroupSubscription_expire_put_V1(
      data
    );
    if (response.success) {
      return response;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
